import {
  Component,
  OnInit,
  TemplateRef,
  ViewChild,
  OnDestroy,
  Input,
  AfterViewInit
} from "@angular/core";
import {
  Validators,
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup
} from "@angular/forms";
import { DatePipe } from "@angular/common";
import { Router } from "@angular/router";
import { MatSelect as MatSelect } from "@angular/material/select";
import { MatOption as MatOption } from "@angular/material/core";
import { startWith, map, } from "rxjs/operators";
import { MatDialog as MatDialog } from "@angular/material/dialog";
import { SharedRequesterService } from "src/app/shared/services/shared-requester.service";
import { DataService } from "src/app/shared/services/data.service";
import { UtilsService } from "src/app/shared/services/utils.service";
import { ExportDialogModel, ExportViewComponent } from "../export-view/export-view.component";
import { RequesterService } from "../../services/requester.service";
import { ManualOutliersRemovalComponent } from "../manual-outliers-removal/manual-outliers-removal.component";
import { HelperService } from "../../services/helper.service";
import { TranslateService } from "@ngx-translate/core";
import { A, AA, B, BATCH, C, CONTINUOS, CUSTOM, DFOSLINES, GRANULARITYCHANGED, HISTOGRAM, LANGUAGECHANGED, MARK_AS_OUTLIER, PAGINATION, SEL_CUSTM_DATE, USLLSLREDZONECHANGE } from "src/app/app.contant";

@Component({
  selector: 'app-statistics',
  templateUrl: './statistics.component.html',
  styleUrls: ['./statistics.component.scss'],
  standalone: false
})
export class StatisticsComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild('custdateSelector') custdateSelector: TemplateRef<any>;
  @ViewChild('pop') pop: any;
  @ViewChild('select') select: MatSelect;
  @ViewChild('selectParameter') selectParameter: MatSelect;
  @ViewChild('markAsOutlier') markAsOutlier: TemplateRef<any>;
  @Input() grapType;
  grapTypes: any;
  today: any;
  selCustmDate: any = JSON.parse(JSON.stringify(SEL_CUSTM_DATE));
  appliedFilter: any = {
    status: false
  };
  samplingGroup: any[] = [2, 3, 4, 5, 6, 7, 8];
  lineList: any[] = [];
  lineListFilter: any[] = [];
  machineList: any[] = [];
  machineListFilter: any[] = [];
  periodList: any[];
  masterData;
  summaryData;
  isSummary = false;
  skuList: any[];
  skuListFilter: any[];
  skuRunList: any[];
  criticalityFilter: any;
  parametersFilter = new UntypedFormControl([]);
  pageno = new UntypedFormControl(0);
  statisticsForm: UntypedFormGroup;
  subscription: any;
  subscriptionUslLsl: any;
  selectedPoints: any[] = [];
  selectedParam: any = {};
  intervalTimer: any;
  latestRunningSKU = "";
  menuExpanded: any;
  filteredList: any = {
    sku: []
  };
  batch: any = false;
  autoCompleteStatus: any = {
    sku: false,
  };
  urlSplit: any = [];
  firstIndex: any = 0;
  lastIndex: any = 5;
  filterUslLsl;
  filterRedZone: any;
  chartfirstIndex: any;
  chartlastIndex: any;
  timeSeriesLength: any;
  timeSeriesData: any = [];
  showOutlier: boolean;
  populateFilter = false;
  selectedLine: any;
  selectedMachine: any;
  selectedPeriod: any;
  selectedParamList: any;
  selectedSku: any;
  machineArray: any = [];
  paramArray: any = [];
  manualOutlierFor: any = null;
  allSelected = null;
  allParameterSelected = false;
  paramList: any = [];
  paramListFilter: any = [];
  sortedParamList: any = [];
  dialogRef: any;
  onGoingSKURun: {};
  showSpinner = false;
  completePercent = 20;
  count = 0;
  pagination = false;
  listenerFunction: any;
  continousFilter: any;
  chartsType;
  toggleType: any = "timeseries";
  isCapability: any = false;
  outlierType = new Map();
  MarkAsOutlierOnwithobviousoutlier: boolean = true;
  MarkAsOutlierOnHistoricalData: boolean = true;
  public isSku = true;
  public isSubmitFromUI: boolean = false;
  public sKeys: any = {};
  currentLanguage: any;
  dfosLineName: any;
  max20 = false;
  lastFiftyPoints: any;
  lastOneHour: any;
  lastFifteenDays: any;
  customDate: any;
  historical: any;
  latestRunSKU: any;
  mySubscription: any;
  public sortOrder: Array<string> = [AA, A, B, C];
  public totalPoints: number = 0;
  public isPaginatorVisible: boolean = false;
  isactiveSku = true;

  constructor(
    public fb: UntypedFormBuilder,
    private sharedRequester: SharedRequesterService,
    private requester: RequesterService,
    private dataSer: DataService,
    private service: HelperService,
    private dialog: MatDialog,
    public utilSer: UtilsService,
    private datePipe: DatePipe,
    private router: Router,
    private translate: TranslateService
  ) {
    this.urlSplit = this.router.url.split('/');
    this.checkUrl();
    this.subscription = this.dataSer.events.subscribe((res: any) => {
      if (res.name === GRANULARITYCHANGED) {
        this.initializeVals();
        this.firstIndex = 0;
        this.lastIndex = 5;
        this.resetsessionStorage();
        this.paramList = [];
        this.paramListFilter = [];
        this.parametersFilter.setValue([]);
        this.allParameterSelected = false;
        this.continousFilter = {};
        this.pageno.setValue(0);
      } else if (res.name === USLLSLREDZONECHANGE) {
        this.getCharts();
      }
      if (res.name === LANGUAGECHANGED) {
        this.currentLanguage = res.args[0];
        this.getLines();
        setTimeout(() => {
          window.location.reload();
        }, 300);
      }
      if (res.name === DFOSLINES) {
        this.dfosLineName = JSON.parse(res.args).data;
        this.getLines();
        //  this.changeDisplayOfLineName();
      }
    });
    this.listenerFunction = this.service.listen().subscribe((response: any) => {
      if (response.success && response.functionality === MARK_AS_OUTLIER) {
        this.pagination = true;
        const element = this.masterData ? this.masterData.find((item) => item.id === response.paramElement) : null;
        this.getParamData(
          element,
          this.continousFilter.period,
          this.continousFilter.sku,
          this.continousFilter.line
        );
      }
      if (response.success && response.functionality === PAGINATION) {
        this.chartChange(response.paramElement, response.index, response.type);
      }
    });
  }

  ngAfterViewInit() {
    this.grapTypes = this.grapType;
  }

  getSigmaValue(value: number): number {
    return parseFloat((Math.abs(value) < 1e-10 ? 0 : value).toFixed(2));
  }

  initializeVals() {
    this.machineList = [];
    this.machineListFilter = [];
    this.masterData = [];
    if (this.grapType === 'summary') {
      this.periodList = [{
        name: this.lastOneHour,
        code: "hour",
        value: 1,
      }];
    } else {

      this.periodList = [
        {
          name: this.lastFiftyPoints,
          code: "50points",
        },
        {
          name: this.customDate,
          code: "custom",
        },
      ];

      if (this.batch) {
        this.periodList.splice(1, 0, {
          name: this.lastFifteenDays,
          code: CUSTOM,
          value: "last-15days",
        });

        this.periodList[2].name = this.historical;
        this.periodList[2].value = CUSTOM;
      }
      else if (!this.batch) {
        this.periodList.unshift({
          name: this.lastOneHour,
          code: "hour",
          value: 1,
        });
        this.periodList.splice(2, 0, {
          name: this.lastFifteenDays,
          code: CUSTOM,
          value: "last-15days",
        });
        this.periodList[3].name = this.historical;
        this.periodList[3].value = CUSTOM;
      }
      if (this.isCapability) {
        if (!this.batch) {
          this.periodList.splice(1, 1);
        } else {
          this.periodList.splice(0, 1);
        }
      }
    }
    this.criticalityFilterInitialize();
    this.statisticsForm = this.fb.group({
      line: ['', Validators.required],
      machine: [[], Validators.required],
      period: ['', Validators.required],
      sku: ['', Validators.required],
      sampling: [5, Validators.required],
      type: ['Continous', [Validators.required]],
      skurunperiod: ['']
    });
    //  this.statisticsForm.controls.period.disable();
    this.setAutoCompleteStatus("sku", false);
    this.selCustmDate = JSON.parse(JSON.stringify(SEL_CUSTM_DATE));
    if (this.grapType === 'manual') {
      const type: string = sessionStorage.getItem('selectedStatisticsType');
      if (type) {
        this.statisticsForm.controls.type.setValue(type);
      }
      this.onTypeChange(false);
    } else {
      this.getLines(false);
    }
  }

  criticalityFilterInitialize(): void {
    this.criticalityFilter = {
      AA: true, B: true,
      A: true, C: true
    };
  }

  ngOnInit() {
    this.lastOneHour = this.translate.instant('common.lastonehour'),
      this.lastFifteenDays = this.translate.instant('common.customdaterange'),
      this.customDate = this.translate.instant('common.customdate'),
      this.historical = this.translate.instant('common.custom_data_historical'),
      this.lastFiftyPoints = this.translate.instant('common.lastfiftypoints'),
      this.latestRunSKU = this.translate.instant('menuList.latestrunsku');
    const lbl: string = this.grapType ? this.grapType : 'process';
    this.sKeys = this.service.sessionKeys[lbl];
    this.initializeVals();
    this.chartfirstIndex = 0;
    this.chartlastIndex = 299;
    this.filterSKUBasedonInputChange();
    this.dataSer.getMenuStatus().subscribe((result) => {
      this.menuExpanded = result;
    });
    this.allSelected = JSON.parse(sessionStorage.getItem(this.sKeys['allSelected']));
    this.allParameterSelected = JSON.parse(sessionStorage.getItem(this.sKeys['allParameterSelected']));
    this.sharedRequester.setStartTimer();
    const lang = sessionStorage.getItem('languageMaster');
    const line = localStorage.getItem('dfosLines');
    this.currentLanguage = lang ? JSON.parse(lang).language : '';
    this.dfosLineName = line ? JSON.parse(line).data : [];
  }

  checkUrl() {
    this.chartsType = this.batch ? "Batch" : "Continous";
    if (this.urlSplit[7] === "statistics-batch" || this.urlSplit[5] === "da") {
      this.batch = true;
      this.chartsType = this.batch ? "Batch" : "Continous";
      if (this.urlSplit[6] === "xbar-r") {
        this.isCapability = true;
        this.toggleType = "x";
      }
    } else if (this.urlSplit[7] === "capability-charts") {
      this.isCapability = true;
      this.toggleType = "x";
    } else if (this.urlSplit[5] === "manual-entry") {
      this.chartsType = this.batch ? "Batch" : "manualContinuous";
    }
  }

  setSkuRunValidator() {
    if (this.statisticsForm.value.period.code === "custom") {
      this.statisticsForm.controls[`skurunperiod`].setValidators([Validators.required]);
      this.statisticsForm.controls[`skurunperiod`].updateValueAndValidity();
    } else {
      this.statisticsForm.controls[`skurunperiod`].clearValidators();
      this.statisticsForm.controls[`skurunperiod`].updateValueAndValidity();
    }
  }

  filterSKUBasedonInputChange() {
    this.isactiveSku = this.statisticsForm.value.sku?.IsActive;
    this.statisticsForm.controls.sku.valueChanges.pipe(
      startWith(""),
      map(value =>
        this.utilSer.autoCompleteFilter(value, this.skuList, "skuName")
      )
    ).subscribe(filteredArray => {
      console.log(filteredArray);
      console.log(Array.isArray(filteredArray));
      // console.log(filteredArray);
      // console.log(Array.isArray(filteredArray));
      // Unwraps the Observable in TS, safely passing the array to HTML file (For new *ngFor to @for upgrade changes)
      this.filteredList.sku = filteredArray;
    });
  }

  public setTosessionStorage(): void {
    const key: any = this.sKeys;
    let str: string = JSON.stringify(this.statisticsForm.value.line);
    sessionStorage.setItem(key['line'], str);

    str = JSON.stringify(this.statisticsForm.value.machine);
    sessionStorage.setItem(key['machine'], str);

    str = JSON.stringify(this.parametersFilter.value);
    sessionStorage.setItem(key['paramFilter'], str);

    str = JSON.stringify(this.statisticsForm.value.period);
    sessionStorage.setItem(key['period'], str);

    str = JSON.stringify(this.statisticsForm.value.skurunperiod);
    sessionStorage.setItem(key['skurunperiod'], str);

    str = JSON.stringify(this.statisticsForm.value.sku);
    sessionStorage.setItem(key['sku'], str);

    str = JSON.stringify(this.allSelected);
    sessionStorage.setItem(key['allSelected'], str);

    str = JSON.stringify(this.allParameterSelected);
    sessionStorage.setItem(key['allParameterSelected'], str);
  }

  public resetsessionStorage(): void {
    const key: any = this.sKeys;
    sessionStorage.removeItem(key['line']);
    sessionStorage.removeItem(key['machine']);
    sessionStorage.removeItem(key['paramFilter']);
    sessionStorage.removeItem(key['period']);
    sessionStorage.removeItem(key['sku']);
    sessionStorage.removeItem(key['allSelected']);
    sessionStorage.removeItem(key['skurunperiod'],);
  }

  public onFilterApply(eventType?: any, fromUI: boolean = false): void {

    if (this.max20 && this.grapTypes === 'summary') {
      return;
    }
    const code: string = this.statisticsForm.value.period.code;
    let customPeriodValue: string = this.statisticsForm.value.period.value;
    let customPeriodcode: string = this.statisticsForm.value.period.code;
    //console.log(customPeriodcode, 'customPeriodcode check value')

    this.showSpinner = true;
    this.isSubmitFromUI = fromUI;
    if (eventType) {
      this.criticalityFilterInitialize();
    }
    if (eventType === true) {
      this.setTosessionStorage();
    }
    if (this.grapTypes === 'summary' && code === 'hour') {
      this.firstIndex = 0;
      this.lastIndex = 20;
    } else if (code === 'hour' || code === '50points') {
      this.firstIndex = 0;
      this.lastIndex = 5;
    } else {
      this.firstIndex = 0;
      this.lastIndex = 1;
    }
    this.appliedFilter = {
      status: true,
      period: this.statisticsForm.value.period,
    };
    this.pagination = false;
    this.pageno.setValue(0);
    if (!fromUI) {
      setTimeout(() => {
        this.continousFilter = this.statisticsForm.value;
        if (this.continousFilter.period.code === 'custom' && this.continousFilter.skurunperiod !== '') {
          this.getCharts();
        } else if (this.continousFilter.period.code !== 'custom') {
          this.getCharts();
        } else {
          this.showSpinner = false;
        }
        this.selectedPoints = [];
      }, 6000);
    } else {
      this.continousFilter = this.statisticsForm.value;
      this.getCharts();
      this.selectedPoints = [];
    }


    if (customPeriodValue == 'custom' || customPeriodcode == '50points') {
      this.MarkAsOutlierOnHistoricalData = false;

    }
    else {
      this.MarkAsOutlierOnHistoricalData = true;


    }
  }

  setChartIndexs() {
    this.masterData = this.masterData.map((v) => ({
      ...v,
      chartfirstIndex: 0,
      chartlastIndex: 299,
      yzoom: { max: 0, min: 0, zoom: false, enableInput: false },
      selectedSku: this.continousFilter.sku ? this.continousFilter.sku.skuName : null,
      isHistogram: false,
    }));
  }

  getLines(initialCall?: boolean) {
    this.lineList = [];
    this.lineListFilter = [];
    this.sharedRequester.getLines(this.chartsType).subscribe((resp: any) => {
      if (!resp || resp.length === 0) {
        return;
      }
      resp = this.utilSer.sortWrtCharAndNum(resp, "linename");
      this.lineList = resp;
      this.lineListFilter = resp;
      this.utilSer.changeDisplayOfLineName(this.lineListFilter, this.currentLanguage, this.dfosLineName);

      if (initialCall) {
        if (resp.length > 1) {
          return;
        }
        this.statisticsForm.controls.line.setValue(this.lineList[0]);
        this.statisticsForm.controls.line.setValue(this.lineListFilter[0]);
        this.getMachines(true);
        this.getSKUs();
      } else if (sessionStorage.getItem(this.sKeys['line']) &&
        sessionStorage.getItem(this.sKeys['machine']) && sessionStorage.getItem(this.sKeys['paramFilter']) &&
        sessionStorage.getItem(this.sKeys['period']) && sessionStorage.getItem(this.sKeys['sku'])
      ) {
        const str: string = sessionStorage.getItem(this.sKeys['line']);
        const line: any = JSON.parse(str);
        const ln: any = resp.find((e: any) => e.id === line.id);
        if (ln) {
          this.checkUrl();
          this.statisticsForm.controls.line.setValue(ln);
          this.getMachines(true);
        }
      }
    });
  }

  public onTypeChange(initialCall: boolean = true): void {
    const type: string = this.statisticsForm.controls.type.value;
    this.chartsType = type === 'Batch' ? BATCH : CONTINUOS;
    this.batch = type === "Batch";
    sessionStorage.setItem('selectedStatisticsType', type);
    this.getLines(initialCall);
    this.paramList = [];
    this.paramListFilter = [];
    this.machineList = [];
    this.machineListFilter = [];
    this.masterData = [];
    this.periodList = [
      {
        name: this.lastFiftyPoints,
        code: "50points",
      },
      {
        name: "Custom Date Range",
        code: CUSTOM,
      }
    ];
    if (this.batch) {
      this.periodList = [
        {
          name: this.lastFiftyPoints,
          code: "50points",
        },
        {
          name: this.lastFifteenDays,
          code: CUSTOM,
          value: "last-15days",
        },
        {
          name: this.historical,
          code: CUSTOM,
          value: CUSTOM
        }
      ];

    }
    if (!this.batch) {
      this.periodList.unshift({
        name: this.lastOneHour,
        code: "hour",
        value: 1,
      });
      this.periodList.splice(2, 0, {
        name: this.lastFifteenDays,
        code: CUSTOM,
        value: "last-15days",
      });
      this.periodList[3].name = this.historical;
      this.periodList[3].value = CUSTOM;
    }
    if (this.isCapability) {
      if (!this.batch) {
        this.periodList.splice(1, 1);
      } else {
        this.periodList.splice(0, 1);
      }
    }
  }

  lineChanged() {
    this.resetsessionStorage();
    const val: any = this.isCapability && this.batch;
    this.statisticsForm.controls.period.setValue(val ? null : this.periodList[0]);
    this.statisticsForm.controls.period.enable();
    if (this.statisticsForm.value.period) {
      this.getSKUs();
    }
    this.getMachines();
    this.paramList = [];
    this.paramListFilter = [];
    this.parametersFilter.setValue([]);
    this.allSelected = false;
  }

  periodChanged(ev) {
    if (ev && ev.value && (ev.value.code === "hour" || ev.value.code === "50points")) {
      this.getSKUs();

    }

  }

  getMachines(initialCall?: boolean) {
    this.checkUrl();
    this.machineList = [];
    this.machineListFilter = [];
    this.statisticsForm.controls.machine.setValue('');
    this.sharedRequester
      .getMachinesUnderLine(this.statisticsForm.value.line, this.chartsType)
      .subscribe((resp: any) => {
        if (!resp || resp.length === 0) {
          this.statisticsForm.controls['machine'].setErrors({ "noMachineFound": true });
          return;
        }
        resp = this.utilSer.sortWrtCharAndNum(resp, "machinename");
        this.machineList = resp;
        this.machineListFilter = resp;
        if (
          JSON.parse(sessionStorage.getItem(this.sKeys['line'])) &&
          JSON.parse(sessionStorage.getItem(this.sKeys['machine'])) &&
          JSON.parse(sessionStorage.getItem(this.sKeys['period'])) &&
          JSON.parse(sessionStorage.getItem(this.sKeys['sku']))
        ) {
          this.selectedLine = this.lineList.find((item) => item.id === JSON.parse(sessionStorage.getItem(this.sKeys['line'])).id);
          this.selectedMachine = JSON.parse(sessionStorage.getItem(this.sKeys['machine']) || '[]');
          this.machineArray = [];
          for (const i of this.selectedMachine || []) {
            if (!i) {
              continue;
            }
            const m: any = this.machineList.find((item) => item.id === i.id);
            this.machineArray.push(m);
          }
          let ssPeriod: any = JSON.parse(sessionStorage.getItem(this.sKeys['period']));
          ssPeriod = ssPeriod ? ssPeriod : '';
          this.selectedPeriod = this.periodList.find((item) => item.code === ssPeriod.code);
          this.statisticsForm.controls.period.enable();
          this.selectedSku = JSON.parse(sessionStorage.getItem(this.sKeys['sku']));
          this.populateFilter = true;
          if (this.selectedLine && this.selectedMachine && this.selectedPeriod && this.selectedSku) {
            const patch: any = {
              line: this.selectedLine,
              machine: this.machineArray,
              period: this.selectedPeriod,
              sku: this.selectedSku,
            };
            if (ssPeriod.code === CUSTOM) {
              const srPeriod: any = JSON.parse(sessionStorage.getItem(this.sKeys['skurunperiod']));
              patch['skurunperiod'] = srPeriod;
            }
            this.statisticsForm.patchValue(patch);
            this.getParamsUnderMachine({ storage: true });
          }
          setTimeout(() => {
            this.getSKUs(initialCall);
          }, 1000);
        } else {
          this.populateFilter = false;
        }

        if ((initialCall && !this.populateFilter) || resp.length === 1) {
          this.statisticsForm.controls.machine.setValue([this.machineList[0]]);
          this.statisticsForm.controls.machine.setValue([this.machineListFilter[0]]);
          this.allSelected = true;
          this.getParamsUnderMachine();
        }
      });
  }

  filterOnlyTaggedSku(skuList) {
    let paramSkuList = [];
    let isAllSkuPresentInParam = false;
    this.parametersFilter.value.forEach(e => {
      if (e && e.sku !== null) {
        e.sku.forEach(element => {
          paramSkuList.push(element.skuname);
        });
      } else {
        isAllSkuPresentInParam = true;
      }
    });

    if (!isAllSkuPresentInParam) {
      return skuList = skuList.filter((el: any) => {
        return paramSkuList.includes(el.skuName);
      });
    } else {
      return skuList;
    }
  }

  getSKUs(initialCall?: boolean, type = { storage: false }) {
    this.isSku = true;
    this.skuList = [];
    this.skuListFilter = [];
    this.statisticsForm.controls.sku.setValue('');
    let lineID = "";
    if (this.statisticsForm.value.line && this.statisticsForm.value.line.id) {
      lineID = this.statisticsForm.value.line.id;
    }
    if (JSON.parse(sessionStorage.getItem('selCustmDate'))) {
      const sessionDate = JSON.parse(sessionStorage.getItem('selCustmDate'));
      this.selCustmDate = {
        from: new Date(sessionDate.from),
        to: new Date(sessionDate.to),
        convertedFrom: new Date(sessionDate.convertedFrom),
        convertedTo: new Date(sessionDate.convertedTo)
      };
    }
    this.sharedRequester
      .getSKUsWithinTimeRange(lineID, this.statisticsForm.value.period, this.selCustmDate)
      .subscribe((resp: any) => {
        const currentPeriod = this.statisticsForm.value.period;
        if (!resp || resp.length === 0) {
          if (currentPeriod) {
            this.isSku = false;
            this.skuList = [];
            this.skuListFilter = [];
            this.filterSKUBasedonInputChange();
            const formValue = this.statisticsForm.value;
            const currentPeriod = formValue.period;
            const hasLine = formValue.line && formValue.line.id;
            const hasMachine = formValue.machine && formValue.machine.length > 0;
            const hasParam = this.paramListFilter && this.paramListFilter.length > 0;

            if (currentPeriod && hasLine && hasMachine && hasParam) {
              this.statisticsForm.controls['sku'].markAsTouched();
              this.statisticsForm.controls['sku'].setErrors({ 'noSkuFound': true });
            }
            return;
          }
        }

        this.statisticsForm.controls['sku'].setErrors(null);
        this.statisticsForm.controls['sku'].updateValueAndValidity();
        resp = this.filterOnlyTaggedSku(resp);
        //  resp = this.utilSer.sortWrtCharAndNum(resp, "skuName");
        resp = resp.sort((a, b) => b.startTimeEpoch - a.startTimeEpoch);
        const period = this.statisticsForm.value.period;
        if (period && period.code === "50points") {
          this.skuList = [
            {
              skuName: this.latestRunSKU,
              code: "allSKUs",
            }
          ];
          this.skuListFilter = [
            {
              skuName: this.latestRunSKU,
              code: "allSKUs",
            }
          ];

        } else {
          this.skuList = resp;
          this.skuListFilter = resp;
        }
        if (this.skuList.length === 1) {
          this.statisticsForm.controls.sku.setValue(this.skuList[0]);
          if (period && period.code === CUSTOM) {
            this.setAutoCompleteStatus("sku", true);
            setTimeout(() => {
              this.getSkuRun(type);
            }, 1000);

          }
        }
        if (this.skuList.length > 1 && type && type.storage) {
          if (period && period.code === CUSTOM) {
            this.setAutoCompleteStatus("sku", true);
            setTimeout(() => {
              this.getSkuRun(type);
            }, 1000);

          }
        }
        this.filterSKUBasedonInputChange();
        this.statisticsForm.controls.skurunperiod.setValue('');
        if (this.skuList.length === 0) {
          this.isSku = false;
        }
        let sku: any = sessionStorage.getItem(this.sKeys['sku']);
        if (sku && initialCall) {
          sku = JSON.parse(sku);
          //for latest run translations
          if (sku.code === "allSKUs") {
            sku = this.skuList[0];
          }
          this.statisticsForm.controls.sku.setValue(sku);
          if (period && period.code !== CUSTOM) {
            this.setAutoCompleteStatus("sku", true);
          }
        }
      });

  }

  getSkuRun(type = { storage: false }) {
    this.skuRunList = [];
    this.statisticsForm.controls.skurunperiod.setValue('');
    if (this.statisticsForm.value.period.code === CUSTOM) {
      let lineID = "";
      if (this.statisticsForm.value.line && this.statisticsForm.value.line.id) {
        lineID = this.statisticsForm.value.line.id;
      }
      if (!this.statisticsForm.value.sku) {
        return;
      }
      this.requester.GetSkuSpecificRunListBasedOnTimeRange(
        lineID, this.statisticsForm.value.period, this.statisticsForm.value.sku, this.selCustmDate)
        .subscribe((resp: any) => {
          resp.sort((a: any, b: any) => b.startTimeEpoch - a.startTimeEpoch);
          this.skuRunList = resp.map((respElem: any) => {
            return {
              skuId: respElem.skuId,
              name: respElem.skuName,
              respStartTS: respElem.startTimeEpoch,
              respEndTS: respElem.endTimeEpoch,
              startTime: new Date(this.utilSer.timeStampConverter(respElem.startTimeEpoch * 1000, false)),
              endTime: !respElem.endTimeEpoch ? null : new Date(this.utilSer.timeStampConverter(respElem.endTimeEpoch * 1000, false))
            };
          });
          if (this.skuRunList && this.skuRunList.length === 1 && type && type.storage === false) {
            this.statisticsForm.controls.skurunperiod.setValue(this.skuRunList[0]);
          }
          if (type && type.storage) {
            const srPeriod: any = JSON.parse(sessionStorage.getItem(this.sKeys['skurunperiod']));
            if (this.skuRunList.filter((e) => e.respEndTS == srPeriod.respEndTS && e.respStartTS == srPeriod.respStartTS)[0]) {
              setTimeout(() => {
                this.statisticsForm.controls.skurunperiod.setValue(this.skuRunList.filter((e) => e.respEndTS == srPeriod.respEndTS && e.respStartTS == srPeriod.respStartTS)[0]);

              }, 4000);
            }
            this.onFilterApply("onbuttonClick");
          }

        });
    } else {
      this.setSkuRunValidator();
    }
  }

  getParameter(event: any) {
    if (!event) {
      if (this.statisticsForm.value.machine.length > 0) {
        this.paramList = [];
        this.paramListFilter = [];
        this.parametersFilter.setValue([]);
        this.allParameterSelected = false;
        this.getParamsUnderMachine();
      } else {
        this.parametersFilter.setValue([]);
        this.paramList = [];
        this.paramListFilter = [];
        this.allParameterSelected = false;
      }
    }
  }

  closeParam(opened: boolean) {
    if (!opened) {
      this.getSKUs();
    }
  }

  getParamsUnderMachine(type?: any) {
    let machine;
    if (type && type.storage) {
      machine = this.machineArray;
    } else {
      machine = this.statisticsForm.value.machine;
    }
    this.allParameterSelected = false;
    this.sharedRequester.getParametersUnderMachineMultiple(machine, this.batch, false, this.chartsType)
      .subscribe((resp: any) => {
        if (resp && resp.length > 0) {
          //  resp = this.utilSer.sortWrtCharAndNum(resp, "parametername");
          this.paramList = resp;
          this.paramListFilter = resp;
          if (this.grapTypes === "manual") {
            this.paramList = this.paramList.filter(
              (data) => data.datasource === "Manual"
            );
            this.paramListFilter = this.paramListFilter.filter(
              (data) => data.datasource === "Manual"
            );
          }
          if (type && type.storage) {
            this.selectedParamList = JSON.parse(sessionStorage.getItem(this.sKeys['paramFilter']));
            this.paramArray = [];
            for (const i of this.selectedParamList) {
              const el = this.paramList.find((item: any) => item && i && item.id === i.id);
              this.paramArray.push(el);
            }
            this.parametersFilter.setValue(this.paramArray);
            if (this.statisticsForm.value.period.code !== CUSTOM) {
              this.onFilterApply("onbuttonClick");
            }
            this.getSKUs(true, type);
          } else if (this.paramList.length === 1) {
            this.parametersFilter.setValue([this.paramList[0]]);
            this.allParameterSelected = true;
            this.getSKUs(true, type);
          }
        }
      });
  }

  // display param result if selected skue is tagged with param
  public skuExists(value, arr) {
    if (value === "Latest Run") {
      return true;
    } else if (arr !== null) {
      return arr.some(function (el) {
        return el.skuname === value;
      });
    } else {
      return true;
    }
  }

  public getCharts(): void {
    this.outlierType = new Map();
    this.masterData = [];
    this.masterData = this.utilSer.sortByClassificationPriority(
      [...this.parametersFilter.value].filter((el: any) => {
        if (!el) {
          return false;
        }
        const normalizedClassification = (el.classification ?? '').toString().trim().toUpperCase();
        const skuFound = this.skuExists(this.continousFilter.sku ? this.continousFilter.sku.skuName : null, el.sku);
        if (((normalizedClassification === AA && this.criticalityFilter.AA) ||
          (normalizedClassification === A && this.criticalityFilter.A) ||
          (normalizedClassification === B && this.criticalityFilter.B) ||
          (normalizedClassification === C && this.criticalityFilter.C)) && skuFound) {
          return el;
        }
      }), 'classification'
    );
    this.masterData = this.formatResponseForParams(this.masterData);
    const histogram: boolean = this.toggleType === HISTOGRAM;

    this.setChartIndexs();
    if (this.masterData.length === 0) {
      this.showSpinner = false;
    }
    this.masterData.slice(this.firstIndex, this.lastIndex).forEach((el: any, i: number) => {
      el.filter.usl_lsl = this.isCapability ? false : JSON.parse(sessionStorage.getItem("usl_lsl"));
      el.filter.redZone = JSON.parse(sessionStorage.getItem("redZoneFilter"));
      el.isHistogram = histogram;
      this.getParamData(el, this.continousFilter.period,
        this.continousFilter.sku, this.continousFilter.line);
    });
    sessionStorage.setItem('masterDatasessionStorage', JSON.stringify(this.masterData));
    this.clearTimer();
    if (this.continousFilter.period.code !== CUSTOM) {
      this.updateGraphsInterval();
    }
  }

  updateGraphsInterval() {
    this.intervalTimer = setInterval(() => {
      this.masterData
        .slice(this.firstIndex, this.lastIndex)
        .forEach((element, i) => {
          this.getParamData(
            element,
            this.continousFilter.period,
            this.continousFilter.sku,
            this.continousFilter.line
          );
        });
    }, 30000);
  }

  clearTimer() {
    if (this.intervalTimer) {
      clearInterval(this.intervalTimer);
    }
  }

  formatResponseForParams(arr) {
    arr.forEach((param) => {
      param.filter = {
        usl_lsl: true,
        rule7: true,
        rule6: true,
        rule1: true,
        outliers: false,
        obiousOutlier: false,
      };
    });
    return arr;
  }

  getParamData(paramDtls, timeDtls, skuDtls, lineDtls, loader?) {
    this.summaryData = [];
    this.isPaginatorVisible = false;
    if (this.statisticsForm.value.period.code === CUSTOM && this.toggleType !== HISTOGRAM) {
      this.isPaginatorVisible = true;
    }
    if (paramDtls) {
      this.latestRunningSKU = '';
      const loaderNeeded = false;
      const type = this.outlierType.get(paramDtls.id);
      const Capability = {
        type: this.isCapability,
        subgroupSize: this.continousFilter.sampling,
        isRChart: this.toggleType === "x" ? false : true,
        outlierType: type ? type : 0
      };

      this.chartfirstIndex = paramDtls.chartfirstIndex;
      this.chartlastIndex = paramDtls.chartlastIndex;
      this.requester
        .getTimeSeriesData(paramDtls, timeDtls, skuDtls, lineDtls, this.selCustmDate, loaderNeeded, false, Capability,
          this.chartfirstIndex, this.chartlastIndex, this.continousFilter.skurunperiod)
        .subscribe((resp) => {
          if (!resp) {
            this.customLoader();
            return;
          }
          this.customLoader();
          const ind = this.masterData.map((item) => item.id).indexOf(paramDtls.id);
          this.masterData[ind].moreRecords = resp.moreRecords ? resp.moreRecords : false;
          if (resp.skuName) {
            this.latestRunningSKU = resp.skuName;
          }

          this.masterData[ind].summaryflag = true;

          if (resp.timeSeriesDatas && resp.timeSeriesDatas.length) {
            this.isSummary = true;
            this.timeSeriesLength = resp.timeSeriesDatas.length;
            resp.timeSeriesDatas.sort((a: any, b: any) => a.tsEpoch - b.tsEpoch);
            this.mapKPIAndParamVals(paramDtls.id, resp.timeSeriesDatas, resp.kpIs, resp.skuName);
          }
          let cnt = 0;
          this.masterData.forEach((el: any) => {
            if (el.summaryflag !== undefined) {
              cnt = cnt + 1;
            }
          });
          if (this.masterData.length === cnt) {
            this.summaryData = this.masterData;
          }
          if (resp.kpIs) {
            this.totalPoints = resp.kpIs.totalPoints || resp.kpIs.totalDataPoints;
          }
          this.isPaginatorVisible = this.isPaginatorVisible && this.totalPoints > 0;
        }, (error: any) => {
          this.showSpinner = false;
        });
    }
  }

  public chartChange(item: any, index: number, type?: string) {
    const ind = this.masterData.map((data: any) => data.id).indexOf(item.id);
    const cf: any = this.continousFilter;
    const md: any = this.masterData[ind];
    const last: number = index * 300 - 1;
    const first: number = index * 300 - 300;
    md.chartfirstIndex = first;
    md.chartlastIndex = last;

    this.pagination = true;
    this.selectedPoints = [];
    this.showSpinner = true;
    this.getParamData(item, cf.period, cf.sku, cf.line);
  }

  customLoader() {
    const currentLength = this.masterData.slice(
      this.firstIndex,
      this.lastIndex
    ).length;
    this.count = this.count + 1;
    this.completePercent = this.completePercent + 20;
    if (currentLength === this.count || this.count === 5 || this.pagination) {
      this.completePercent = 100;
      this.showSpinner = false;
      this.completePercent = 20;
      this.count = 0;
      this.pagination = false;
    }
  }

  mapKPIAndParamVals(id, timeSeriesData, kpi, assignedSKUText) {
    timeSeriesData.forEach((element, i) => {
      if (this.isCapability) {
        const key = "k" + "" + i;
        element.convertedTS = key;
        element.batch = key;
        element.sp = null;
      } else {
        if (this.chartsType = !this.batch) {
          element.convertedTS = this.utilSer.timeStampConverter(
            element.tsEpoch * 1000,
            false
          );
        }
        else if (this.chartsType = this.batch) {
          element.convertedTS = this.utilSer.timeStampConverter(element.tsEpoch * 1000, false);
        }

      }
    });

    const index = this.masterData.map((item) => item.id).indexOf(id);

    this.masterData[index].assignedSKUText = assignedSKUText;
    this.masterData[index].timeSeriesData = timeSeriesData;
    this.masterData[index].kpi = kpi;

    if (timeSeriesData.some((item) => item.manualOutlier)) {
      this.masterData[index].manualOutlierPresent = true;
    } else {
      this.masterData[index].manualOutlierPresent = false;
    }

    if (timeSeriesData.some((item) => !item.outlier)) {
      this.masterData[index].allOutliers = false;
    } else {
      this.masterData[index].allOutliers = true;
    }
  }

  periodClick() {
    if (this.statisticsForm.value.period.code === CUSTOM) {
      //  this.skuList = [];
      //  this.skuListFilter = [];
      //  this.statisticsForm.controls.sku.setValue('');
      this.dialog.open(this.custdateSelector, {
        width: "755px",
        height: "550px",
      });
    }
    this.setSkuRunValidator();
  }

  applyCustomDate(evt: any) {
    this.selCustmDate = {
      from: evt.from,
      to: evt.to,
      convertedFrom: new Date(
        this.utilSer.timeStampConverter(+evt.from, false)
      ),
      convertedTo: new Date(this.utilSer.timeStampConverter(+evt.to, false)),
    };
    sessionStorage.setItem('selCustmDate', JSON.stringify(this.selCustmDate));
    this.dialog.closeAll();
    this.getSKUs();
  }

  toggleOutliers(item: any) {
    item.filter.usl_lsl = this.isCapability ? false : true;
    item.filter.rule1 = true;
    item.filter.rule6 = true;
    item.filter.rule7 = true;
    item.filter.outliers = !item.filter.outliers;
  }

  generateCSV(item: any) {
    console.log('download data check', item.timeSeriesData)
    let period;
    if (this.continousFilter.period.code === CUSTOM) {
      period =
        this.datePipe.transform(this.continousFilter.skurunperiod.startTime, 'MMM d, y, HH:mm') + ' - ' +
        this.datePipe.transform(this.continousFilter.skurunperiod.endTime, 'MMM d, y, HH:mm');
    } else {
      period = this.continousFilter.period.name;
    }
    console.log(period, 'period check')
    const cluster: any = JSON.parse(sessionStorage.getItem('selectedCluster'));
    const factory: any = JSON.parse(sessionStorage.getItem('selectedFactory'));
    item.clusterFactoryDtls = {
      clusterName: cluster ? cluster.name : null,
      clusterId: null,
      factoryName: factory ? factory.name : null,
      factoryId: null
    };
    const dialogData = new ExportDialogModel(item, period, this.isCapability);
    this.dialog.open(ExportViewComponent, {
      width: '70%',
      height: '95%',
      panelClass: 'export-dialog',
      data: dialogData
    });
  }

  afterOutlierSubmit(event) {
    if (event) {
      this.pagination = true;
      this.getParamData(this.selectedParam, this.continousFilter.period,
        this.continousFilter.sku, this.continousFilter.line, true);
      this.selectedPoints = [];
      this.selectedParam = null;

    }
  }

  openPopupforOutlier(item) {
    this.showOutlier = true;
  }

  selectedPointsChange(points: any, item: any) {
    this.selectedPoints = points;
    this.selectedParam = item;
  }

  setAutoCompleteStatus(field, value, fromUI = false) {
    this.autoCompleteStatus[field] = value;
    this.isactiveSku = this.statisticsForm.value.sku.IsActive;
    if (field === 'sku' && fromUI) {
      const str: any = JSON.stringify(this.statisticsForm.value.sku);
      sessionStorage.setItem(this.sKeys['sku'], str);
    }
  }

  pageChange(index, type) {
    if (type === "next") {
      this.firstIndex = this.lastIndex;
      this.lastIndex = this.lastIndex + 5;
      this.showSpinner = true;
      this.getCharts();
    } else if (type === "back" && index > 0) {
      this.lastIndex = this.firstIndex;
      this.firstIndex = this.firstIndex - 5;
      this.showSpinner = true;
      this.getCharts();
    }
    document.getElementById("top").scrollIntoView();
  }

  threewayApi(item, index, type) {
    if (type === "with-Outlier_" + index) {
      this.outlierType.set(item.id, 0);
    } else if (type === "with-ob-Outlier_" + index) {
      this.outlierType.set(item.id, 1);
    } else {
      this.outlierType.set(item.id, 2);
    }
    const ind = this.masterData.map((data) => data.id).indexOf(item.id);
    this.pagination = true;
    this.selectedPoints = [];
    this.getParamData(
      item,
      this.continousFilter.period,
      this.continousFilter.sku,
      this.continousFilter.line
    );
  }

  threeWayBtn1(item, event, index) {
    if (this.isCapability) {
      this.threewayApi(item, index, event.currentTarget.id);
    }
    this.selectedPoints = [];
    //  this.selectedParam = null;
    item.filter.obiousOutlier = false;
    if (item.filter.outliers && event.currentTarget.id === "with-Outlier_" + index) {
      this.toggleOutliers(item);
    } else if (item.filter.outliers && event.currentTarget.id === "with-ob-Outlier_" + index) {
      item.filter.obiousOutlier = !item.filter.obiousOutlier;
      this.toggleOutliers(item);
    } else if (event.currentTarget.id === "without-Outlier_" + index) {
      this.toggleOutliers(item);
    } else if (event.currentTarget.id === "with-ob-Outlier_" + index) {
      item.filter.obiousOutlier = !item.filter.obiousOutlier;
    }

    if (!item.filter.outliers && !item.filter.obiousOutlier &&
      event.currentTarget.id === "with-Outlier_" + index && !event.currentTarget.checked) {
      item.filter.outliers = false;
      item.filter.obiousOutlier = false;
      (document.getElementById("with-Outlier_" + index) as HTMLFormElement).checked = true;
    } else if (!item.filter.outliers && item.filter.obiousOutlier &&
      event.currentTarget.id === "with-ob-Outlier_" + index && !event.currentTarget.checked) {
      item.filter.outliers = false;
      item.filter.obiousOutlier = true;
      (document.getElementById("with-ob-Outlier_" + index) as HTMLFormElement).checked = true;
    }
    /*******************************************Test */
    if (event.currentTarget.id === "with-ob-Outlier_" + index) {

      if (item.filter.obiousOutlier) {
        this.MarkAsOutlierOnwithobviousoutlier = false;
      }
    } else {
      this.MarkAsOutlierOnwithobviousoutlier = true;

    }
  }

  setPageIndex() {
    if (this.parametersFilter.value.length > 0) {
      this.firstIndex = 0;
      this.lastIndex = 5;
    }
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
    this.clearTimer();
    // this.resetsessionStorage();
    this.listenerFunction.unsubscribe();
    const title = this.batch ? "DA-Batch charts" : "SPC-Continuous charts";
    this.sharedRequester.userAnalytics({ screenName: title });
  }

  removeManualOutliers(param) {
    this.dialog
      .open(ManualOutliersRemovalComponent, {
        width: "450px",
        maxHeight: "550px",
        panelClass: "manualOutlierRemovalPopup",
        data: {
          pointsArr: param.timeSeriesData.filter((item) => item.manualOutlier),
          selParam: {
            id: param.id,
            tagname: param.tagname,
            batch: param.batch,
          },
        },
      })
      .afterClosed()
      .subscribe((selectedItem) => {
        this.pagination = true;
        if (selectedItem && selectedItem.id) {
          this.getParamData(
            param,
            this.continousFilter.period,
            this.continousFilter.sku,
            this.continousFilter.line,
            true
          );
        }
      });
  }

  /*chartChange(item, index, type) {
    const ind = this.masterData.map((data) => data.id).indexOf(item.id);
    this.pagination = true;
    this.selectedPoints = [];
    if (type === "next") {
      this.showSpinner = true;
      this.masterData[ind].chartfirstIndex =
        this.masterData[ind].chartlastIndex + 1;
      this.masterData[ind].chartlastIndex =
        this.masterData[ind].chartlastIndex + 300;
      this.getParamData(
        item,
        this.continousFilter.period,
        this.continousFilter.sku,
        this.continousFilter.line
      );
    } else if (type === "back" && index > 0) {
      this.showSpinner = true;
      this.masterData[ind].chartlastIndex =
        this.masterData[ind].chartfirstIndex - 1;
      this.masterData[ind].chartfirstIndex =
        this.masterData[ind].chartfirstIndex - 300;
      this.getParamData(
        item,
        this.continousFilter.period,
        this.continousFilter.sku,
        this.continousFilter.line
      );
    }
  }*/

  toggleAllSelection() {
    if (this.allSelected) {
      this.select.options.forEach((item: MatOption) => item.select());
    } else {
      this.select.options.forEach((item: MatOption) => item.deselect());
    }
  }

  optionClick() {
    let newStatus = true;
    if (this.select) {
      this.select.options.forEach((item: MatOption) => {
        if (!item.selected) {
          newStatus = false;
        }
      });
    }
    this.allSelected = newStatus;
  }

  toggleAllParameterSelection() {

    if (this.allParameterSelected) {
      this.selectParameter.options.forEach((item: MatOption) => item.select());
    } else {
      this.selectParameter.options.forEach((item: MatOption) =>
        item.deselect()
      );
    }
    this.maxparamvalidation();
  }

  maxparamvalidation() {
    if (this.parametersFilter.value.length > 20) {
      this.max20 = true;
    } else {
      this.max20 = false;
    }
  }

  optionParameterClick() {
    let newParameterStatus = true;
    this.selectParameter.options.forEach((item: MatOption) => {
      if (!item.selected) {
        newParameterStatus = false;
      }
    });
    this.allParameterSelected = newParameterStatus;
    this.maxparamvalidation();
  }

  openMarkAsOutlierPopup(item) {
    if (this.selectedParam.id === item.id) {
      this.dialogRef = this.dialog.open(this.markAsOutlier, {
        width: "400px",
        height: "360px",
      });
    }
  }

  onToggle(toggleEvent: any) {
    if (toggleEvent.value === "timeseries") {
      this.toggleType = "timeseries";
      this.masterData = this.masterData.map((v) => ({
        ...v,
        isHistogram: false,
      }));
      this.getCharts();
    } else if (toggleEvent.value === "histogram") {
      this.toggleType = "histogram";
      this.masterData = this.masterData.map((v) => ({
        ...v,
        isHistogram: true,
      }));
      this.getCharts();
    } else if (toggleEvent.value === "x") {
      this.toggleType = "x";
      this.masterData = this.masterData.map((v) => ({
        ...v,
        isHistogram: true,
      }));
      this.getCharts();
    } else if (toggleEvent.value === "r") {
      this.toggleType = "r";
      this.masterData = this.masterData.map((v) => ({
        ...v,
        isHistogram: true,
      }));
      this.getCharts();
    }
  }

  setYBound(paramDtls: any, event: any) {
    const ind = this.masterData.map((data) => data.id).indexOf(paramDtls.id);
    if (event.action === "set") {
      this.masterData[ind].yzoom.max = event.max;
      this.masterData[ind].yzoom.min = event.min;
      this.masterData[ind].yzoom.zoom = true;
    } else if (event.action === "change") {
      this.masterData[ind].yzoom.zoom = false;
    } else {
      this.masterData[ind].yzoom.max = 0;
      this.masterData[ind].yzoom.min = 0;
      this.masterData[ind].yzoom.zoom = false;
      this.masterData[ind].yzoom.enableInput = false;
    }
  }

  pageNumChange() {
    // this.outlierType = new Map();
    if (this.pageno.value > 0) {
      this.firstIndex = this.pageno.value + 1 - 1;
      this.lastIndex = this.pageno.value + 1;
    } else if (this.pageno.value === 0) {
      this.firstIndex = 0;
      this.lastIndex = 1;
    }
    this.showSpinner = true;
    this.getCharts();
    document.getElementById("top").scrollIntoView();
  }
}